import i18n from './i18n'

export const getSlugTranslation = (phraseKey: string) => {
  const slug = window.location.pathname.split('/')[1]
  return i18n.exists(`${phraseKey}.${slug}`) ? i18n.t(`${phraseKey}.${slug}`) : i18n.t(phraseKey)
}
